import { Injectable, inject } from '@angular/core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { NotificationService } from '../../../services/notification.service';
import { switchMap, withLatestFrom, map, catchError } from 'rxjs/operators';
import { of, Observable } from 'rxjs';
import { Store } from '@ngrx/store';
import * as fromStore from '../../../store';
import * as featureActions from '../../index';
import { NotificationActionTypes, NotificationActions } from '../actions/notification.actions';



@Injectable()
export class NotificationEffects {
  private actions$ = inject(Actions);
  private store$ = inject(Store<fromStore.State>);
  private notificationService = inject(NotificationService);

  constructor() {}

  GetNotification$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.NotificationActionTypes.GetNotifications),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]) => {
      return this.notificationService.ReadNotification(user.otp).pipe(
        switchMap((res) => {
          // if (res.result && Array.isArray(res.msg.body)) {
          if (res.result) {
            // const dcodeList = res.msg.body.filter(item => (item.type === 1 || item.type === 2 || item.type === 3))
            //                               .map(item => parseInt((item.content.split(',')[0]), 10));
            // return [new featureActions.UpsertNotifications({notifications: res.msg.body, isConfirm: res.msg.isConfirm}),
            //   new fromStore.GetDeviceInfoAction()];
            return [new featureActions.UpsertNotifications({notifications: res.msg.body, isConfirm: res.msg.isConfirm})];
          } else {
            return of(new featureActions.GetNotificationsFail());
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError(error => {
          return of(new featureActions.GetNotificationsFail());
        })
      );
    })
  ));
  UpdateNotification$ = createEffect(() => this.actions$.pipe(
    ofType(featureActions.NotificationActionTypes.UpdateNotifications),
    withLatestFrom(this.store$.select(fromStore.getCurrentUser)),
    switchMap(([action, user]) => {
      return this.notificationService.UpdateNotification(user.otp).pipe(
        map((res: any) => {
          if (res.Flag) {
            return new featureActions.GetNotifications();
          } else {
            return new featureActions.GetNotificationsFail();
          }
        }),
        // TODO: catchError Message調整 --> 留待未來再回頭定義Error Message
        catchError(error => {
          return of(new featureActions.GetNotificationsFail());
        })
      );
    })
  ));

}
